import { useState } from "react";
import { useParams, Navigate } from "react-router-dom";
import { FaCalendarAlt, FaUser, FaFolder } from "react-icons/fa";
import PageHeader from "../components/layout/PageHeader";
import BlogSidebar from "../components/common/BlogSidebar";
import { blogs } from "../data/blog";

export default function BlogSingle() {
  const { id } = useParams();
  const post = blogs.find((b) => b.id === id);
  const [comments, setComments] = useState(post ? post.comments : []);
  const [form, setForm] = useState({ name: "", text: "" });

  if (!post) return <Navigate to="/blog-grid" replace />;

  const submit = (e) => {
    e.preventDefault();
    if (!form.name || !form.text) return;
    setComments([...comments, form]);
    setForm({ name: "", text: "" });
  };

  return (
    <>
      <PageHeader
        title={post.title}
        bg={post.image}
        crumbs={[{ label: "Blog", to: "/blog-grid" }, { label: "Article" }]}
      />
      <section className="section">
        <div className="container single-layout">
          <div className="single-content">
            <img src={post.image} alt={post.title} className="single-img" />
            <div className="blog-meta" style={{ marginBottom: 20 }}>
              <span><FaCalendarAlt /> {post.date}</span>
              <span><FaUser /> {post.author}</span>
              <span><FaFolder /> {post.category}</span>
            </div>
            <h2 style={{ marginTop: 0 }}>{post.title}</h2>
            {post.content.map((p, i) => <p key={i}>{p}</p>)}

            <div className="tag-list mt-3">
              {post.tags.map((t) => <span key={t}>#{t}</span>)}
            </div>

            <h3 style={{ marginTop: 40 }}>Comments ({comments.length})</h3>
            <div>
              {comments.map((c, i) => (
                <div className="comment" key={i}>
                  <div className="avatar">{c.name.charAt(0)}</div>
                  <div>
                    <h4>{c.name}</h4>
                    <p>{c.text}</p>
                  </div>
                </div>
              ))}
            </div>

            <h3 style={{ marginTop: 36 }}>Leave a Comment</h3>
            <form onSubmit={submit}>
              <div className="field">
                <label>Name</label>
                <input
                  type="text"
                  value={form.name}
                  onChange={(e) => setForm({ ...form, name: e.target.value })}
                  required
                />
              </div>
              <div className="field">
                <label>Comment</label>
                <textarea
                  value={form.text}
                  onChange={(e) => setForm({ ...form, text: e.target.value })}
                  required
                />
              </div>
              <button type="submit" className="btn btn-primary">Post Comment</button>
            </form>
          </div>
          <BlogSidebar />
        </div>
      </section>
    </>
  );
}
